<template>
  <div class="content-panel">
    <a-input-search
      v-model="dimName"
      style="margin-bottom: 8px"
      placeholder="请选择设备"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="spin" class="leftBottomTree">
      <a-card :bordered="false">
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultSelectedKeys"
          :defaultExpandedKeys="defaultSelectedKeys"
          :defaultSelectedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          :draggable="false"
          @expand="onExpand"
          @select="select"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.name }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
    <ul v-show="visible && $auth('equipmentLedger.export')" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="$auth('equipmentLedger.export')" @click="derive()">导出当前台账</li>
    </ul>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getDeviceTypeTree } from '@/api/deviceType'
export default {
  name: 'OrgTree',
  components: {
  },
  data () {
    return {
      expandedKeys: [],
      loading: false,
      dimName: '',
      treeData: [],
      defaultSelectedKeys: ['000000'],
      selectedKeys: ['000000'],
      bukrs: '',
      visible: false,
      top: 0,
      left: 0,
      numberOfOutputs: 0
    }
  },
  created () {
    // 获取资产类型
    this.getAssetType()
  },
  mounted () {
    this.$nextTick(() => {
      const dom = document.getElementsByClassName('leftBottomTree')[0]
      dom.oncontextmenu = this.openContextmenu
    })
  },
  watch: {
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    ...mapActions(['handleEquipmentType']),
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    // 关闭右键菜单
    closeMenu () {
      this.visible = false
    },
    openContextmenu (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('closeMenu', 'leftBottom')
      this.top = e.pageY - 41
      this.left = e.pageX
      this.visible = true
    },
    // // 导入
    // handleImport() {
    //   this.$emit('handleImport')
    // },
    // 导出
    derive () {
      this.$emit('derive')
    },
    formateData (arr, id) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = item.code
          item.scopedSlots = { title: 'custom' }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children)
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取资产类型
    async getAssetType () {
      this.loading = true
      const data = { name: this.dimName.trim() }
      const res = await getDeviceTypeTree(data)
      if (res.status === 0) {
        if (res.data.length > 0) {
          this.loop(res.data)
          if (this.dimName.trim()) {
            this.treeData = res.data
          } else {
            this.treeData = [
              {
                id: '000000',
                key: '000000',
                scopedSlots: { title: 'custom' },
                name: '设备',
                code: '设备分类',
                children: res.data
              }
            ]
          }
          this.defaultSelectedKeys = [this.treeData[0].key]
          this.selectedKeys = [this.treeData[0].key]
        } else {
          this.treeData = []
          this.defaultSelectedKeys = []
          this.selectedKeys = []
        }
        this.handleEquipmentType({
          equipmentType: this.treeData.length > 0 ? this.treeData[0].code : '空',
          equipmentData: this.treeData.length > 0 ? this.treeData[0] : {},
          numberOfOutputs: this.numberOfOutputs++
        })
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    loop (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].scopedSlots = {
          title: 'custom'
        }
        if (data[i].children) {
          this.loop(data[i].children)
        }
      }
    },
    // 调用父组件的获取使用部门数据方法
    select (data, info) {
      if (data.length > 0) {
        this.selectedKeys = data
        let codeData = ''
        if (info.selectedNodes.length === 1) {
          codeData = info.selectedNodes[0].data.props.code
        }
        this.handleEquipmentType({
          equipmentType: codeData,
          equipmentData: info.selectedNodes[0].data.props,
          numberOfOutputs: this.numberOfOutputs++
        })
      }
    },
    // 搜索设备分类
    queryDictData () {
      this.getAssetType()
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  //padding-bottom: 20px;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: rgba(231, 244, 255, 1);
}
</style>
